// extracted by mini-css-extract-plugin
module.exports = {"bodywrapper":"landing_bodywrapper__1cY_Q","bodywrapper2":"landing_bodywrapper2__1i4vS","bodywrapper3":"landing_bodywrapper3__PKg-D","bodywrapper4":"landing_bodywrapper4__2A-q_"};